/**
 * Route for `legacy-mmp-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LegacyMmpIntegrationViaApiPage } from "../features/legacy-mmp-integration-via-api/LegacyMmpIntegrationViaApiPage";

export const legacyMmpIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/legacy-mmp-integration-via-api",
	component: LegacyMmpIntegrationViaApiPage,
});

export default legacyMmpIntegrationViaApiRoute;
